import React, {useEffect, useState} from "react";
import "./PackManCurrent.sass";
import {CurrentCard} from "../CurrentCard/CurrentCard";
import {orderPickerArchivedOrders_api, orderPickerOrders_api} from "../PackManService";

function PackManCurrent({data}) {

    const [currents , set_currents ] = useState([])


    useEffect(()=>{
        set_currents(data)
        orderPickerOrders_func();
    },[data])


    const HandleScrollListener = async () =>{
        const doc = document.documentElement;
        let calc = doc.scrollHeight -(doc.scrollTop + doc.clientHeight)
        let cond = calc>3 || calc<-3
        if(!cond) {
            console.log("bottonnnnn");
            pageinate()
        }
    }

    useEffect(()=>{
        //handle scroll arrived to Top
        window.CuPage = 1;
        window.addEventListener('scroll',HandleScrollListener);
        return () => {
            window.removeEventListener('scroll', HandleScrollListener); // Remove Scroll Event Listener
        };
    },[])

    const orderPickerOrders_func = async () =>{
        try {
            const response = await orderPickerOrders_api(1);
            console.log("Response : ",response);
            set_currents(response.data.results)
        }catch (e) {
            console.log(e)
        }
    }

    const pageinate = async ()=>{
        window.CuPage = window.CuPage+1;
        try{
            const response = await orderPickerOrders_api(window.CuPage);
            set_currents((list)=>[...list,...response.data.results]);
        }catch (e) {
            console.log(e);
        }
    }

    return(
        <div>
            {currents.map(item=>{
                return(
                    <CurrentCard  item={item}/>
                )
            })}
        </div>
    )

}

export {PackManCurrent};
